import React from "react";

class FirstNameField extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="form-field">
                <label>
                    First Name:&nbsp;
                    <input type="text" value={this.props.value} onChange={this.props.onChange} />
                </label>
            </div>
        )
    }
}

export default FirstNameField;
